/**
 * Resolves runtime configuration.
 * Source of truth: docker-oikosMarket/backend.env
 * - Live nginx: window.__ENV from frontend-env.sh
 * - Dev Vite: FRONTEND_* injected into the container / import.meta.env
 */
export type AppConfig = {
  appName: string
  apiBaseUrl: string
  apiKey: string
  baseUrl: string
  isProduction: boolean
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

function readRuntime(): Window['__ENV'] {
  return typeof window !== 'undefined' ? window.__ENV : undefined
}

function readMeta(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name]
  return typeof value === 'string' ? value : ''
}

export function getAppConfig(): AppConfig {
  const runtime = readRuntime()

  const apiBaseUrl =
    runtime?.FRONTEND_API_BASE_URL ||
    readMeta('FRONTEND_API_BASE_URL') ||
    'http://localhost:5098'

  const apiKey = runtime?.FRONTEND_API_KEY || readMeta('FRONTEND_API_KEY') || ''

  const baseUrl =
    runtime?.FRONTEND_BASE_URL ||
    readMeta('FRONTEND_BASE_URL') ||
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8098')

  const appName =
    runtime?.FRONTEND_APP_NAME ||
    readMeta('FRONTEND_APP_NAME') ||
    'Oikos Market'

  const isProduction =
    runtime?.FRONTEND_IS_PRODUCTION === 'true' ||
    readMeta('FRONTEND_IS_PRODUCTION') === 'true' ||
    import.meta.env.PROD

  return {
    appName,
    apiBaseUrl: trimTrailingSlash(apiBaseUrl),
    apiKey,
    baseUrl: trimTrailingSlash(baseUrl),
    isProduction,
  }
}
